// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Placeholders from '../../../../common/Placeholders';
import Snippet from '../../../../common/Snippet/shared/container';
import messages, { fewResults } from './messages';
import styles from './styles';
import { DEFAULT_AD_IMAGES_TO_LOAD } from './constants';

type Props = {
  normalizeAds: Array<Object>,
  searchParameters: Object,
  verticalName: string,
  lastFreshAd?: number,
  isFetching: boolean,
  trovit: Object,
  onAdClick: Function,
  dfpBellyComponent?: Object,
};

function ListAds({
  normalizeAds,
  searchParameters,
  verticalName,
  isFetching,
  trovit,
  lastFreshAd,
  onAdClick,
  dfpBellyComponent,
}: Props) {
  let isAlreadyShowingAlternativeAds = false;
  let isAlreadyShowingSimilarContentAds = false;
  let organicAdCount = 0;
  return (
    <div className="list">
      <div className={isFetching ? 'fetching' : null}>
        {normalizeAds.length > 0 ? (
          normalizeAds.map((normalizedAd, index) => {
            const adId = normalizedAd.id;
            const isAdPremium = normalizedAd.premium;
            const isAdFresh = normalizedAd.fresh;
            const isAlternativeAd = normalizedAd.isAlternativeAd;
            const isSimilarContentAd = normalizedAd.isSimilarContentAd;

            if (!isAdPremium) {
              organicAdCount += 1;
            }

            let keyPrefix = 'organic';
            if (isAdFresh) {
              keyPrefix = 'fresh';
            }
            if (isAdPremium) {
              keyPrefix = 'premium';
            }
            if (isSimilarContentAd) {
              keyPrefix = 'similar-content';
            }

            const key = `${keyPrefix}-${adId}`;
            const wasVisited = normalizedAd.visitCount > 0;
            const showDfpBellyComponent =
              organicAdCount === 10 && React.isValidElement(dfpBellyComponent);

            const snippet = (
              <React.Fragment key={key}>
                <Snippet
                  key={key}
                  showBelly={showDfpBellyComponent}
                  ad={normalizedAd}
                  searchParameters={searchParameters}
                  trovit={trovit}
                  wasVisited={wasVisited}
                  lazyLoadImage={index >= DEFAULT_AD_IMAGES_TO_LOAD}
                  onAdClick={onAdClick}
                  dataTestId="results-item"
                />
                {showDfpBellyComponent && <div className="dfp">{dfpBellyComponent}</div>}
              </React.Fragment>
            );

            if (!lastFreshAd && isAlternativeAd && !isAlreadyShowingAlternativeAds) {
              isAlreadyShowingAlternativeAds = true;
              return (
                <span key="alternative_results_title" data-test="alt">
                  <h6>
                    <FormattedMessage
                      {...messages.alterQueryTitle}
                      values={{ '%s': searchParameters.whatAccented }}
                    />
                  </h6>
                  {snippet}
                </span>
              );
            }

            if (
              lastFreshAd !== 0 &&
              (normalizeAds.length > (lastFreshAd || 0) && lastFreshAd === index)
            ) {
              return (
                <span key="more_ads_title">
                  <h6>
                    <FormattedMessage
                      {...messages.moreAdsTitle}
                      values={{ '%s': searchParameters.whatAccented }}
                    />
                  </h6>
                  {snippet}
                </span>
              );
            }

            if (isSimilarContentAd && !isAlreadyShowingSimilarContentAds) {
              isAlreadyShowingSimilarContentAds = true;
              return (
                <span key="similar_content_ads_title">
                  <h6>
                    <FormattedMessage {...fewResults[verticalName]} />
                  </h6>
                  {snippet}
                </span>
              );
            }
            return snippet;
          })
        ) : (
          <Placeholders amount={10} />
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

ListAds.defaultProps = {
  lastFreshAd: 0,
  dfpBellyComponent: {},
};

export default ListAds;



// WEBPACK FOOTER //
// ./app/Serp/components/Lists/ListAds/index.js